/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetAnnouncementResponseData,
  GetAnnouncementResponseDataFromJSON,
  GetAnnouncementResponseDataFromJSONTyped,
  GetAnnouncementResponseDataToJSON
} from './GetAnnouncementResponseData'

/**
 *
 * @export
 * @interface GetAnnouncementResponse
 */
export interface GetAnnouncementResponse {
  /**
   *
   * @type {number}
   * @memberof GetAnnouncementResponse
   */
  status?: number
  /**
   *
   * @type {GetAnnouncementResponseData}
   * @memberof GetAnnouncementResponse
   */
  data?: GetAnnouncementResponseData
}

export function GetAnnouncementResponseFromJSON(json: any): GetAnnouncementResponse {
  return GetAnnouncementResponseFromJSONTyped(json, false)
}

export function GetAnnouncementResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAnnouncementResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetAnnouncementResponseDataFromJSON(json['data'])
  }
}

export function GetAnnouncementResponseToJSON(value?: GetAnnouncementResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetAnnouncementResponseDataToJSON(value.data)
  }
}
